import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RegisterIconsService } from 'src/app/services/register-icons.service';
import { ApiUsuarioService } from 'src/app/services/api-usuario.service';
import { ApiS3Service } from 'src/app/services/api-s3.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { PlatformService } from 'src/app/services/platform.service';
import { select } from 'd3';



@Component({
  selector: 'app-derruba-sessao',
  templateUrl: './derruba-sessao.component.html',
  styleUrls: ['./derruba-sessao.component.scss']
})
export class DerrubaSessaoComponent implements OnInit {

  usuariosLogados;
  dadosForm;
  sessaoEscolhida: any;
  salvando: boolean = false;
  enableButtons: boolean = false;
  message;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<any>,
    private apiUsuario: ApiUsuarioService,
    private apiS3: ApiS3Service,
    private router: Router,
    public snackBar: MatSnackBar,
    private icons: RegisterIconsService,
    private plataform: PlatformService) {
    icons.registerIcons(['close', 'cellphone', 'monitor']);
    this.plataform.deviceType = this.plataform.deviceType != 'desktop' ? 'mobile' : this.plataform.deviceType;
  }

  ngOnInit(): void {
    this.message = this.data.credenciais.message;
    if (this.message === 'Sessões lotadas. Escolha algum usuário da corretora para desconectar da sessão.') {
      this.usuariosLogados = this.data.credenciais.data.filter(usuario => usuario.status === true);
    }
    if (this.message === 'Já existe uma sessão ativa com esse usuário.') {
      this.sessaoEscolhida = this.data.credenciais.data;
    }
    this.dadosForm = this.data.dadosForm;
    if (!this.sessaoEscolhida) {
      this.enableButtons = false
    }

  }

  mudaSelecao() {
    if (this.sessaoEscolhida) {
      this.enableButtons = true
    } else {
      this.enableButtons = false
    }
  }

  async refazLogin(excluirSessoesUsuario?) {
    this.salvando = true
    this.enableButtons = true
    excluirSessoesUsuario ? this.dadosForm.excluirSessoesUsuario = true : this.dadosForm.idSessao = this.sessaoEscolhida.id;
    try {
      let credenciais: any = await this.apiUsuario.login(this.dadosForm);
      credenciais.senha = this.dadosForm.senha;
      this.apiUsuario.armazenaLogin(credenciais);
      this.apiUsuario.avatar = await this.apiS3.loadAvatarUsuarioLogado();
      let path = '/cotacoes';
      this.router.navigateByUrl(path).then(() => {
        this.dialogRef.close();
      });
    } catch (error) {
      let erro;
      if (error && error.error && error.error.message) {
        erro = error.error.message;
      }
      else if (error.status == 0) {
        erro = 'Falha de conexão ao servidor.';
      }
      else {
        erro = 'Falha no login.';
      }
      this.mostraMensagem(erro);
      this.salvando = false
      this.enableButtons = false
    }
  }

  mostraMensagem(mensagem: string) {
    this.snackBar.open(mensagem, 'Ok', {
      duration: 6000,
    });
  }
}
